import { render, staticRenderFns } from "./GerarDocModalForm.vue?vue&type=template&id=f955c16a"
import script from "./GerarDocModalForm.vue?vue&type=script&lang=js"
export * from "./GerarDocModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports